import { Action } from '@ngrx/store';


export enum EUserGroupsListActions {
  GetUserGroups = '[User groups] Get User groups',
  GetUserGroupsSuccess = '[User groups] Get User groups Success',
  DeleteUserGroups = '[User groups] Delete User groups',
  DeleteUserGroupsSuccess = '[User groups] Delete User groups Success',
  ResetUserGroups = '[User groups] ResetUserGroups',
  ResetUserGroupsSuccess = '[User groups] ResetUserGroups Success',
}


export class GetUserGroups implements Action {
  public readonly type = EUserGroupsListActions.GetUserGroups;
}


export class ResetUserGroups implements Action {
  public readonly type = EUserGroupsListActions.ResetUserGroups;
  constructor() { }
}

export class ResetUserGroupsSuccess implements Action {
  public readonly type = EUserGroupsListActions.ResetUserGroupsSuccess;
  constructor() { }
}

export class GetUserGroupsSuccess implements Action {
  public readonly type = EUserGroupsListActions.GetUserGroupsSuccess;
  constructor(public payload: IUserGroup[]) { }
}

export class DeleteUserGroups implements Action {
  public readonly type = EUserGroupsListActions.DeleteUserGroups;
  constructor(public payload: Guid[]) { }
}

export class DeleteUserGroupsSuccess implements Action {
  public readonly type = EUserGroupsListActions.DeleteUserGroupsSuccess;
}

export type UserGroupListActions = GetUserGroups |
ResetUserGroups |
ResetUserGroupsSuccess |
GetUserGroupsSuccess|
DeleteUserGroups |
DeleteUserGroupsSuccess;
